export const LOADER_TRAINING_TYPE          =    'LOADER_TRAINING_TYPE';
export const GET_TRAINING_TYPE             =    'GET_TRAINING_TYPE';
export const TRAINING_TYPE_FAIL            =    'TRAINING_TYPE_FAIL';
export const SAVE_LOADER_TRAINING_TYPE     =    'SAVE_LOADER_TRAINING_TYPE';
export const FORM_TRAINING_TYPE_FAIL       =    'FORM_TRAINING_TYPE_FAIL';

